import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { fetchFamilyMemberById } from "../../service/FamilyMemberApi";
import { Helmet } from "react-helmet-async";
import { Navbar, Footer, Breadcrumbs } from "../../components/shared";
import { Loading } from "../../components/shared";
import { useCheckAccess, getAge, maskAadhar } from "../../utils/Utilities";
import { statusExplanation } from '../general/DropDownValuesConfig';
import { businessNames } from '../general/DropDownValuesConfig';
import { FaUserPlus, FaEdit, FaUsers, FaEye } from "react-icons/fa";
function FamilyMemberView() {
  useCheckAccess('FamilyRO'); // Check if the user is logged in (if no user data, redirect to login)
  const { id } = useParams();
  const navigate = useNavigate();
  const [familyMemberData, setFamilyMemberData] = useState(null);
  const [error, setError] = useState(null);

  // Fetch family data
  useEffect(() => {
    const fetchFamilyMemberData = async () => {
      try {
        if (id) {
          const data = await fetchFamilyMemberById(id);
          setFamilyMemberData(data); // Set the fetched data to state
        }
      } catch (error) {
        setError("Error fetching family member data");
      }
    };

    fetchFamilyMemberData();
  }, [id]);

  if (error) {
    return <div>Error: {error}</div>; // Display error message
  }
  const getBusinessLabel = (value) => {
    const item = businessNames.find(b => b.value === value);
    return item ? item.label : value || "";
  };
  // If data is not available, show loading
  if (!familyMemberData) {
    return (
      <>
        <Navbar />
        <div className="general_parent">
          <div className="general_container">
            <div className="general_body">
              <Breadcrumbs /><br />
              <Loading />
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <Helmet>
        <title>உறுப்பினர் விவரங்கள்</title>
        <link rel="canonical" href={`/family/member-view`} />
      </Helmet>

      <div className="general_parent">
        <div className="general_container">
          <div className="general_body">
            <Breadcrumbs /><br />
            <h3>உறுப்பினர் விவரங்கள்</h3>
            <br />
            <div className="details-card">
              <div className="detail-item">
                <span className="detail-label">குடும்ப எண் :</span>
                <span className="detail-value">{familyMemberData.familyMember.familyId}</span>
              </div>

              {/* Aadhar Number */}
              <div className="detail-item">
                <span className="detail-label">ஆதார் எண்:</span>
                <span style={{ color: familyMemberData.familyMember.maskedAadhar?.startsWith("TMP") ? "red" : "inherit" }}>
                  {maskAadhar(familyMemberData.familyMember.maskedAadhar) || ""}
                </span>

              </div>

              {/* First Name */}
              <div className="detail-item">
                <span className="detail-label">பெயர்:</span>
                <span>{familyMemberData.familyMember.firstName || ""}</span>
              </div>

              {/* Last Name */}
              <div className="detail-item">
                <span className="detail-label">தந்தை / கணவர் பெயர்:</span>
                <span>{familyMemberData.familyMember.lastName || ""}</span>
              </div>


              {/* Business Name */}
              <div className="detail-item">
                <span className="detail-label">வணிக பெயர்:</span>
                <span>{getBusinessLabel(familyMemberData.familyMember.businessName)}</span>
              </div>

              {/* Date of Birth */}
              <div className="detail-item">
                <span className="detail-label">பிறந்த தேதி:</span>
                <span>
                  {familyMemberData.familyMember.dob
                    ? new Date(familyMemberData.familyMember.dob).toLocaleDateString("ta-IN", {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                    })
                    : ""}
                  {familyMemberData.familyMember.dob ? ` (வயது: ${getAge(familyMemberData.familyMember.dob)})` : ""}
                </span>
              </div>

              {/* Mobile Numbers */}
              <div className="detail-item">
                <span className="detail-label">கைபேசி எண்:</span>
                <span>{familyMemberData.familyMember.mobile || ""}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">கைபேசி SMS நிலை:</span>
                <span>{familyMemberData.familyMember.mobileSmsStatus || ""}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">கைபேசி எண் 2:</span>
                <span>{familyMemberData.familyMember.mobile2 || ""}</span>
              </div>

              {/* Email */}
              <div className="detail-item">
                <span className="detail-label">மின்னஞ்சல்:</span>
                <span>{familyMemberData.familyMember.email || ""}</span>
              </div>

              <div className="detail-item">
                <span className="detail-label">நிலை:</span>
                <span style={{ color: ["draft", "inactive", 'pending'].includes(familyMemberData.familyMember.status) ? "red" : "inherit" }}>
                  {familyMemberData.familyMember.status || ""}
                </span>
                <div>
                  <small>{statusExplanation[familyMemberData.familyMember.status] || "அறியப்படாத நிலை."}</small>
                </div>
              </div>

              <div className="detail-item">
                <span className="detail-label">உறவுமுறை:</span>
                {familyMemberData.familyMember.relationship || "Self"} of {maskAadhar(familyMemberData.familyMember.maskedParentId) || "Self"}
              </div>
              <div>
                <table >
                  <tbody>
                    <tr>
                      <td style={{ border: "none", padding: "10px" }}>
                        <button onClick={() => navigate(`/family/member-update/${familyMemberData.familyMember.id}`)}><FaEdit size={20} />  உறுப்பினரை திருத்து</button>
                      </td>
                      <td style={{ border: "none", padding: "10px", justifyContent: "center" }}>
                        <button onClick={() => navigate(`/family/member-create/${familyMemberData.familyMember.familyId}`)}><FaUserPlus size={20} />உறுப்பினர் சேர் </button>
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "none", padding: "10px", justifyContent: "center" }}>
                        <button onClick={() => navigate(`/family/view/${familyMemberData.familyMember.familyId}`)}><FaEye size={20} /> குடும்பத்தை பார்க்க</button>
                      </td>
                      <td style={{ border: "none", padding: "10px", justifyContent: "center" }}>
                        <button onClick={() => navigate(`/family`)}><FaUsers size={20} /> குடும்ப நிர்வாகம்</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <br />

              <br />

              <br />


            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default FamilyMemberView;
